import {
    LaneFeesDetail,
} from 'app/Apps/Pricing/Pricing.types'
import {
    LaneFeesStatus,
} from 'app/enums/label.enums'
import Button from 'app/shared-components/Button'
import useStyles from './LaneFeesSetStatusButtons.style'

type Props = {
    value: LaneFeesDetail
    disabled: boolean
    onCreate: (value: LaneFeesDetail) => void
    isLoading: boolean
}
const LaneFeesSetStatusButtons = ({
    disabled,
    isLoading,
    value,
    onCreate,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()
    const handleCreate = (laneFeesStatus: LaneFeesStatus) => {
        onCreate({
            ...value,
            laneFeesStatus,
        })
    }

    return (
        <>
            <Button
                disabled={disabled}
                label="Set to In Progress"
                onClick={() => {
                    handleCreate(LaneFeesStatus.IN_PROGRESS)
                }}
                saving={isLoading}
                className={classes.button}
            />
            <Button
                disabled={disabled}
                label="Set to Submitted"
                onClick={() => {
                    handleCreate(LaneFeesStatus.SUBMITTED)
                }}
                saving={isLoading}
                className={classes.button}
            />
        </>
    )
}

export default LaneFeesSetStatusButtons
